import { csx } from '@vtex/admin-ui'

const styles = {
  container: csx({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '> *': {
      paddingTop: '$space-1',
    },
  }),
  text: csx({ ':empty': { display: 'none' } }),
  counter: csx({
    marginLeft: 'auto',
  }),
  line: csx({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
}

export default styles
